// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio-module__root___R0ZGp","option":"Radio-module__option____BnlV","optionSelected":"Radio-module__optionSelected___2rhi7"};